jQuery(document).ready(function ($) {
    let selectContainer  = $('.store-selectors-wrapper');
    let countySelect = $('#CountySelector');
    let citySelect = $('#CitySelector');
    let stores = $(".store");
    selectContainer.hide();
    citySelect.hide();
    fetch("/wp-json/storefront-child/v1/store-adresses")
        .then(response => response.json())
        .then(data => {
            let counties = Object.values(data);
            pouplateCounties(counties);
            countySelect.on('change', function (e) {
                e.preventDefault();
                var value = $(this).val();
                var foundCounty = counties.find(x=>x.name == value)
                if(foundCounty) {
                    var cities = foundCounty.cities;
                    citySelect.empty();
                    citySelect.append("<option disabled selected>Velg By</option>");
                    cities.forEach(loc => {
                        var option = `<option value="${loc}">${loc}</option>`;
                        citySelect.append(option);
                    });
                    citySelect.show();
                }
                filterList(stores, value, 'county')
            })
            selectContainer.show()
            paramSelect(citySelect);
        })
        .catch(err => {
            console.error(err);
        });

    

    function pouplateCounties(counties) {
        countySelect.empty();
        countySelect.append("<option disabled selected>Velg Fylke</option>");
        counties.forEach(loc => {
            var option = `<option value="${loc.name}">${loc.name}</option>`;
            countySelect.append(option);
        });
    }


    function filterList(stores, value, type) {
        if (value != "0") {
            stores.hide();
            $(`[data-${type}="${value}"]`).show();
        }
        else {
            stores.show();
        }
    }
    function paramSelect(param) {
        param.on('change', function (e) {
            e.preventDefault();
            filterList(stores, $(this).val(), 'city')
        });
    }

});